import React, { useState, useEffect } from "react";

export default function SemicircleGauge({ raised, goal }) {
  const pct = Math.min(goal > 0 ? raised / goal : 0, 1);
  const radius = 80;
  const stroke = 16;
  const cx = 100;
  const cy = 92;

  const startX = cx - radius;
  const startY = cy;
  const endX = cx + radius;

  const trackPath = `M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${startY}`;
  const fullArcLength = Math.PI * radius;

  // Animate on mount
  const [animatedPct, setAnimatedPct] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => setAnimatedPct(pct), 100);
    return () => clearTimeout(timer);
  }, [pct]);

  const filledDash = fullArcLength * animatedPct;
  const filledGap = fullArcLength - filledDash;

  return (
    <div className="w-[80%] mx-auto">
      {/* SVG gauge */}
      <div className="relative">
        <svg viewBox="0 0 200 100" className="w-full overflow-visible">
          <path
            d={trackPath}
            fill="none"
            stroke="#e5e5e5"
            strokeWidth={stroke}
            strokeLinecap="round"
          />
          {pct > 0 && (
            <path
              d={trackPath}
              fill="none"
              stroke="#dc2626"
              strokeWidth={stroke}
              strokeLinecap="round"
              strokeDasharray={`${filledDash} ${filledGap}`}
              style={{ transition: "stroke-dasharray 1.5s cubic-bezier(0.22, 1, 0.36, 1)" }}
            />
          )}
        </svg>

        {/* Center text — inside the arc */}
        <div className="absolute inset-0 flex items-end justify-center pb-[6px]">
          <div className="text-center">
            <p className="text-4xl font-bold text-black leading-none">
              ${raised.toLocaleString()}
            </p>
            <p className="text-[13px] text-black/35 mt-1">
              {Math.round(pct * 100)}% of goal
            </p>
          </div>
        </div>
      </div>

      {/* Labels below the arc ends */}
      <div className="flex justify-between px-1 -mt-1">
        <span className="text-xs font-medium text-black/35">$0</span>
        <span className="text-xs font-medium text-black/35">
          ${goal.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
